var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-card-download"},[_c('unicom-icone',{staticClass:"icone-file-download",attrs:{"nome":"file","tamanho":20}}),_c('div',[_c('div',[_vm._v(_vm._s(_vm.nomeArquivo))])]),_c('div',{staticClass:"container-circular"},[_c('unicom-icone',{staticClass:"icone-circular",attrs:{"nome":"check","tamanho":14}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }